<template>

    <div class="container">


        <div class="handle-box-search">

            <el-row class="head-search">

                <el-col :span="8">
                    <span class="title">手机号:</span>

                    <!-- 搜索广告名 -->
                    <el-input v-model="search_data.consumer_phone" placeholder="请输入手机号" class="handle-input mr10"
                              @keyup.enter.native="searchprizeRecordLists"></el-input>
                </el-col>


                <el-col :span="8">
                    <span class="title">类型:</span>

                    <el-select v-model="search_data.type" placeholder="请选择" clearable>
                        <el-option
                                label="余额"
                                value="1">
                        </el-option>
                        <el-option
                                label="优惠券"
                                value="2">
                        </el-option>
                        <el-option
                                label="谢谢惠顾"
                                value="0">
                        </el-option>
                    </el-select>
                </el-col>



            </el-row>
            <el-button type="primary" icon="el-icon-search" @click="searchprizeRecordLists">搜索</el-button>

            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">


            <el-table-column prop="consumer_name" label="姓名">
            </el-table-column>

            <el-table-column prop="consumer_phone" label="电话">
            </el-table-column>
            <el-table-column prop="prize_name" label="奖项名称">
            </el-table-column>

            <el-table-column prop="type.alias" label="奖项类型">
            </el-table-column>

            <el-table-column prop="amount" label="金额">
            </el-table-column>
            <el-table-column prop="coupon_name" label="优惠券">
            </el-table-column>

            <el-table-column prop="time.YmdHis" label="时间">
            </el-table-column>




        </el-table>


        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>





    </div>

</template>

<script>
    var _this;
    export default {

        data() {
            return {


                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                },


                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },
            };
        },
        created() {
            _this = this;
            _this.prizeRecordLists();
        },

        methods: {


            searchprizeRecordLists() {

                _this.search_data.page = 1;
                _this.prizeRecordLists();

            },
            // 搜索司机日志列表
            prizeRecordLists() {
                _this.$post(
                    "/prize/prizeRecordLists",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                    }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.prizeRecordLists();

            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>
